// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__woaBh","text":"index_text__j5cWw","error":"index_error__oPTjP","title":"index_title__IxvhG","downloadWrapper":"index_downloadWrapper__cJrQJ"};